module.exports = __webpack_public_path__ + "img/sustainability.1be642af.svg";